<template>
  <div class="download-app-page">
    <img
      class="wx-img"
      v-if="isWeChat"
      src="../../assets/images/download-app/wx-download.png"
      alt=""
    />
    <div class="download-wrap" v-else>
      <img
        v-if="isIOS"
        src="../../assets/images/download-app/ios-download.png"
        alt=""
      />
      <img v-else src="../../assets/images/download-app/download.png" alt="" />
      <button class="down-btn" v-preventReClick @click="dowmloadAPP"></button>
    </div>
  </div>
</template>

<script>
import { isWeChat, isIOS, isAndroid } from "@saas/components/src";
import {
  getAndroidAppVersion,
  getIosAppVersion,
} from "@saas/server-api/src/index";
const protocol = process.env.VUE_APP_DESKTOP_PROTOCAL || 'comettech://';
export default {
  data: function () {
    return {
      iosUrl: process.env.VUE_APP_IOS_API,
      androidUrl: "",
      isWeChat: false,
      isIOS: false,
      isAndroid: false,
    };
  },
  mounted() {
    this.isWeChat = isWeChat();
    this.isIOS = isIOS();
    this.isAndroid = isAndroid();
    document.title = this.$route.meta.routeTitle;
    if (this.isWeChat) {
      // if (this.isIOS) {
      //   window.location.href =
      //     "https://apps.apple.com/app/%E9%AD%94%E6%9E%9C%E4%BA%91%E8%AF%BE/id6503724524";
      // }
    } else {
      this.apiGetDownloadUrl();
      // if (this.isAndroid) {
      //   window.location.href = "comettech://openpage";
      // }
    }
  },
  methods: {
    dowmloadAPP() {
      let urlKey = "androidUrl";
      if (this.isIOS) {
        urlKey = "iosUrl";
      }
      window.open(this[urlKey]);
    },
    apiGetDownloadUrl() {
      let fn = getAndroidAppVersion;
      let urlKey = "androidUrl";
      if (this.isIOS) {
        fn = getIosAppVersion;
        urlKey = "iosUrl";
      }
      fn().then((res) => {
        if (res.code === 1 && res?.data?.url) {
          this[urlKey] = res.data.url;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.download-app-page {
  min-height: 100vh;
  background: #e3f8ec;
  padding-bottom: 1.33rem;
  img {
    margin: 0 auto;
  }
  .download-wrap {
    position: relative;
    .down-btn {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      // border: 1px solid red;
      width: 4rem;
      height: 1.33rem;
      border-radius: 0.67rem;
    }
  }
}
</style>
